import React from 'react';
import { Box, Typography } from '@mui/material';
import { Assessment } from '@mui/icons-material';

/**
 * ReportsDirectoryHeader - Header section for the reports directory page
 */
const ReportsDirectoryHeader: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderBottom: '2px solid #3b82f6',
        p: 2.5
      }}
    >
      <Box display="flex" alignItems="center" gap={2}>
        <Assessment sx={{ color: '#3b82f6', fontSize: '1.75rem' }} />
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 600, color: '#1e293b' }}>
            Reports
          </Typography>
          <Typography variant="body2" sx={{ color: '#64748b' }}>
            Select a report category to view analytics and insights
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ReportsDirectoryHeader;
